module.exports = __webpack_public_path__ + "img/IEC27492.4f8bdad0.png";